import { useState } from 'react'
import { VOICE_POSITIONS } from '@gogrov/shared'
import type { Voice } from '@/types/database'

/** The three-segment control. Positions are ordered by how much authority the
 *  creator claims, never by heat. */
export function VoiceSegments({ value, onChange, large = false, disabled = false, owned }: {
  value: Voice
  onChange: (v: Voice) => void
  large?: boolean
  disabled?: boolean
  /** Voices already written for this story, marked so switching reads as free. */
  owned?: Set<Voice>
}) {
  return (
    <div className={`gg-seg${large ? ' gg-seg--lg' : ''}`} role="group" aria-label="Voice position">
      {VOICE_POSITIONS.map((p) => (
        <button
          key={p.id}
          type="button"
          aria-pressed={value === p.id}
          disabled={disabled}
          onClick={() => onChange(p.id)}
          title={p.line}
        >
          {p.label}
          {large && <small>{p.claim}{owned?.has(p.id) ? ' · written' : ''}</small>}
        </button>
      ))}
    </div>
  )
}

/** The amber "i": opens the positions card inline. Hidden when the user has
 *  turned voice reminders off. */
export function VoiceInfo({ show }: { show: boolean }) {
  const [open, setOpen] = useState(false)
  if (!show) return null
  return (
    <span className="voice-info">
      <button type="button" className="gg-info" aria-label="About voice positions" aria-expanded={open} onClick={() => setOpen((o) => !o)}>i</button>
      {open && (
        <div className="gg-note voice-card" role="note">
          <span className="eyebrow eyebrow--accent">Voice positions · how much authority you claim</span>
          {VOICE_POSITIONS.map((p) => (
            <div key={p.id} className="voice-card__row"><b>{p.label}</b><span>{p.line}</span></div>
          ))}
          <div className="voice-card__foot">
            <span>Turn these reminders off in Settings.</span>
            <button type="button" className="gg-btn gg-btn--sm" onClick={() => setOpen(false)}>Close</button>
          </div>
        </div>
      )}
    </span>
  )
}

export const REPORTER_NOTE =
  'Reporter draws the fewest comments. There is no ask at the end: it trades engagement for credibility.'
